export default "__VITE_ASSET__c40964cc__"